import React from 'react'
import InnerBanner from './InnerBanner';
import NightLifeInner from './NightLifeInner';

const NightLife = ()=>{
    return(
        <div>
          <InnerBanner />
           <NightLifeInner />
        </div>
    )
}

export default NightLife;